import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/pcas/pcas";
import relationPcas from "../../models/pcas/relationPcas";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    pcasRelations: [],
    pcas: [],
    roles: [],
    newRelations: [],
    delRelations: [],
  },

  mutations: {
    setPcasRelations(state, data) {
      state.pcasRelations = data;
    },
    setPcas(state, data) {
      state.pcas = data;
    },
    setRoles(state, data) {
      state.roles = data;
    },
    setNewRelations(state, data) {
      state.newRelations = data;
    },
    setDelRelations(state, data) {
      state.delRelations = data;
    },
  },
  actions: {
    async getPcasRelations(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getPcasRelations();
          state.commit("setPcasRelations", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getPcas(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getPcas();
          state.commit("setPcas", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getRoles(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getRoles();
          state.commit("setRoles", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async addRelation(state) {
      try {
        await state.state.service.addRelation(state.state.newRelations);
        let item = await state.state.service.getPcasRelations();
        state.commit("setPcasRelations", item);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteRelation(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const payload = {
            pcaid: state.state.delRelations.pcaId,
            rolid: state.state.delRelations.roles[0],
          };

          await state.state.service.deleteRelation(payload);

          let relationIndex = state.state.pcasRelations.findIndex(
            (pcaItem) => pcaItem.pcaId === state.state.delRelations.pcaId
          );

          if (relationIndex !== -1) {
            let relation = state.state.pcasRelations[relationIndex];
            relation.roles = relation.roles.filter(
              (role) => role.rolId !== state.state.delRelations.roles[0]
            );
            if (relation.roles.length === 0) {
              state.state.pcasRelations.splice(relationIndex, 1);
            } else {
              state.state.pcasRelations[relationIndex] = relation;
            }
          }
          state.commit("setPcasRelations", state.state.pcasRelations);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
